import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Permissions from '../components/Permissions';
import {popupHide} from '../actions/popup';
import {FormattedMessage} from 'react-intl';

class PermissionsPopup extends React.Component {

  handleClose(ev) {
    ev.preventDefault();
    this.props.dispatch(popupHide());
  }

  closeFixedPopup(ev) {
    if (ev.target === this.popup) {
      this.props.dispatch(popupHide());
    }
  }

  render() {
    const {data, isDemoMode} = this.props;
    const close = () => this.props.dispatch(popupHide());

    return (
      <div className="permissions fixed-popup fixed-popup-center" ref={(i) => this.popup = i} onClick={(ev) => this.closeFixedPopup(ev)}>
        <div className="vertical-align-helper"></div>
        <div className="permission-popup fixed-popup-centered">
          <div className="permission-popup-head">
            <div className="permission-popup-head-text typography_h2"><FormattedMessage id="permisions.popup.headline"/></div>
            <a className="close-icon-button" href="#" onClick={(ev) => this.handleClose(ev)}>
              <svg width="25" height="25" viewBox="0 0 25 25"><path d="M11.793 12.5L8.146 8.854 7.793 8.5l.707-.707.354.353 3.646 3.647 3.646-3.647.354-.353.707.707-.353.354-3.647 3.646 3.647 3.646.353.354-.707.707-.354-.353-3.646-3.647-3.646 3.647-.354.353-.707-.707.353-.354 3.647-3.646z"></path></svg>
            </a>
          </div>
          <Permissions app={data} isDemoMode={isDemoMode} close={close}/>
        </div>
      </div>
    );
  }

  static propTypes = {
    data: PropTypes.object,
    dispatch: PropTypes.func,
    isDemoMode: PropTypes.bool
  };
}


function mapStateToProps(state) {
  return {
    data: state.popup.data,
    isDemoMode: !!state.mode.query.demoMode
  };
}

export default connect(mapStateToProps)(PermissionsPopup);



// WEBPACK FOOTER //
// ./containers/Permissions-popup.js